import axios from 'axios';
import { sessionService } from '../services/sessionService';

export const axiosInstance = axios.create({
    baseURL: process.env.NODE_ENV === 'production' 
        ? 'https://api.codebreakers.online' 
        : 'http://localhost:8080'       
});

//: Apply interceptors to axiosInstance
axiosInstance.interceptors.request.use(
    (config) => {
        const token = sessionService.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            sessionService.logout();
        }
        return Promise.reject(error);
    }
);